export class PepFamilia {

    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        nombre_completo: {
            value: '',
            export: false,
            header: 'Apellidos y Nombres Completos:',
            required: 'Información requerida',
            maxLength: 'Máximo 500 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 500,
            min: 3,
            table: true,
            filter: false,
            sort: true
        },
        parentezco: {
            value: '', export: true, header: 'Parentesco:', required: 'Campo requerido', maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 100, min: 4, table: true
        },
        identificacion: {
            value: '',
            export: false,
            header: 'No. doc. Identificación:',
            required: 'No. RUC / Identificación es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 3 caracteres',
            table: true,
            max: 50,
            min: 3
        },
        tipo_identificacion: {
            value: null,
            export: false,
            header: 'Tipo de documento:',
            required: 'Selecione una opción',
            table: true,
        },
        razon_social: {
            value: '',
            export: false,
            header: 'Razón Social o Denominación de la Entidad, Empresa o Institución Pública donde cumple o cumplió funciones la Persona Expuesta Políticamente:',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 300,
            min: 3
        },
        direccion: {
            value: '',
            export: false,
            header: 'Dirección de la Entidad, Empresa o Institución Pública:',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 300,
            min: 3
        },
        pais: {
            value: null,
            export: false,
            header: 'País:',
            required: 'País es requerido'
        },
        provincia: {
            value: null,
            export: false,
            header: 'Provincia:',
            required: 'Provincia es requerido'
        },
        ciudad: {
            value: null,
            export: false,
            header: 'Cantón/Ciudad:',
            required: 'Ciudad es requerida'
        },
        canton: {
            value: '',
            export: false,
            header: 'Cantón/Ciudad:',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 100,
            min: 3,
            required: 'Ciudad es requerida'
        },
        tipo_relacion: {
            value: '',
            export: false,
            header: 'Tipo de Relación:',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 100,
            min: 3,
            required: 'Campo requerido'
        },
        mantiene_cargo: {
            value: null,
            export: true,
            header: 'Actualmente se mantiene en el cargo:',
            required: 'Campo requerido',
            table: false
        },
        fecha_inicio: {
            value: new Date(),
            export: false,
            header: 'Fecha Inicio de funciones:',
            required: 'Fecha es requerido',
            table: false,
            sort: true,
        },
        fecha_fin: {
            value: new Date(),
            export: false,
            header: 'Fecha Término de funciones:',
            required: 'Fecha es requerido',
            table: false,
            sort: true,
        },
        tipo_cargo: {
            value: null,
            export: true,
            header: 'Tipo de Cargo',
            required: 'Campo requerido',
            table: false
        },
        cargo: {
            value: '',
            export: false,
            header: 'Función o cargo que desempeñó o desempeña:',
            required: 'Información requerida',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 300,
            min: 3,
            table: false,
            filter: false,
            sort: true
        },
        rmu: {
            value: 0,
            export: true,
            table: false,
            header: 'Remuneración Mensual Unificada:',
            required: 'Valor requerido',
            min: 0,
            minLength: 'Valor mínimo requerido es 0',
        },
    }
    optionLabel = 'nombre'
}
